import React from 'react'
import { paddingHorizontal, paddingVertical } from '../utils/AppConstants'
import {useMediaQuery} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import HeaderCommon from '../commonComponents/HeaderCommon'

const CommonRoutes = ({ component }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
      <div
        style={{
          height: '110px'
        }}
      >
        <HeaderCommon />
      </div>
      <div
        style={{
          height: `calc(100% - 57px)`,
          overflow: 'auto',
          padding: `${paddingVertical} ${isMobile?'20px':paddingHorizontal}`
        }}
      >
        {component}
      </div>
    </div>
  )
}

export default CommonRoutes
